import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class OpenTicketEscalationLevel extends Component {
    state = {
        OpenTicketEscalationLevelLists:[],
        OpenTicketEscalationLevelValue: '',
        isOpenTicketEscalationLevelLoading: true
    };
    componentDidMount(){
        this.getOpenTicketEscalationLevel();
    }
    restOpenTicketEscalationLevelFilter() {
        this.setState({
            OpenTicketEscalationLevelValue: [],
        })
    }
    getOpenTicketEscalationLevel(){
        axios.get(config.get('API_URL')+'/filters/get-escalation-level/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                user_type: this.props.userType,
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((escalation_level, index) => {
                    this.state.OpenTicketEscalationLevelLists.push({value: escalation_level.escalation_level, label: escalation_level.escalation_level})
                });
            }
            this.setState({
                isOpenTicketEscalationLevelLoading: false
            })
        });

    }


    changeOpenTicketEscalationLevel(optionSelected){
        let value='';
        let tenderArray = [];
        if(optionSelected.length < 1){
            value = null;
            tenderArray = '';
        }
        else{
            optionSelected.map((ids, i) => {
                tenderArray.push(ids.value)
                var index = this.state.OpenTicketEscalationLevelLists.findIndex(obj => obj.value==ids.value);
                this.state.OpenTicketEscalationLevelLists.move(index,0).join(',');
            });
        }
        this.props.onSelectOpenTicketEscalationLevel(optionSelected, tenderArray);
        this.setState({
            OpenTicketEscalationLevelValue:optionSelected,
        });

    }
    render() {

        return (
            <ReactMultiSelectCheckboxes name="event_name"
                isMulti
                value={this.state.OpenTicketEscalationLevelValue}
                styles={reactSelectStyles} className="report-listbox"
                isClearable={false}
                onChange={this.changeOpenTicketEscalationLevel.bind(this)}
                options={this.state.OpenTicketEscalationLevelLists}
                placeholderButtonLabel="Select [Escalation Level]"
                isLoading={this.state.isOpenTicketEscalationLevelLoading}
            />
        );

    }
}
export default OpenTicketEscalationLevel;